import React from 'react';
import LogoImage from 'Components/logo';
import durationFormat from 'Misc/duration-format';
import sonicImage from 'Misc/sonic-image';
import playerStates from 'Misc/player-states';
import translations from 'Translations';

import './player-ui.scss';

const PlayerUI = (props) => (
  <div className={`player-ui 
    ${props.state.player.state === playerStates.playing ? 'player-ui--hidden' : ''}
    ${props.state.player.state === playerStates.pause ? 'player-ui--paused' : ''}
    `}>
    <LogoImage darkBackground={true} />
    <div className="player-ui__state-icon">
      {(
        props.state.player.state === playerStates.buffering 
        || props.state.player.state === playerStates.seeking
        || props.state.player.state === playerStates.seeked
      )  
      && <div className="player-ui__state-icon__buffering"></div>}
      {props.state.player.state === playerStates.playing && <div className="player-ui__state-icon__playing"></div>}
      {props.state.player.state === playerStates.pause && <div className="player-ui__state-icon__paused"></div>}
    </div>
    {
      (props.state.media) ?
      <div className="player-ui__info">
        <div className="player-ui__media">
          <div className="player-ui__image-container">
            <div className="player-ui__image player-ui__image--fallback"></div>
            { props.state.media.metadata.images 
              && props.state.media.metadata.images.length 
              && props.state.media.metadata.images[0].url
              && <div className="player-ui__image" 
                style={{backgroundImage: `url(${sonicImage(props.state.media.metadata.images[0].url, 160)})`}}>
              </div>
            }
          </div>
          <div className="player-ui__titles">
            <div className="player-ui__title">{props.state.media.metadata.title}</div>
            <div className="player-ui__subtitle">{ (props.state.media.streamType === 'LIVE') ? translations[props.settings.APP_NAME].live : props.state.media.metadata.subtitle }</div>
          </div>
        </div>
        { props.state.duration ? 
          <div className="player-ui__controls">
            {
            (props.state.media.streamType === 'LIVE') ?
              <div className="player-ui__live">{translations[props.settings.APP_NAME].live}</div>
            : 
              <div className="player-ui__time">
                <div className={`player-ui__time__current ${props.state.duration > 3600 ? 'player-ui__time__current--long' : ''}`}>
                  {durationFormat(props.state.currentTime, props.state.duration)}
                </div>
                <div className="player-ui__time__duration">{durationFormat(props.state.duration)}</div>
              </div>
            }
            <div className="player-ui__progressbar">
              <div className="player-ui__progressbar__played" style={{width: `${props.state.currentTime / props.state.duration * 100}%`}}></div>
            </div>
          </div>
        : null }
      </div>
      : null
    }
  </div>
);

export default PlayerUI;



// WEBPACK FOOTER //
// ./src/components/player-ui/index.js